import { getStorageItem, setStorageItem, removeStorageItem, STORAGE_KEYS } from '@/utils/storage';

const state = {
    token: getStorageItem(STORAGE_KEYS.TOKEN),
    externalUserId: getStorageItem(STORAGE_KEYS.EXTERNAL_USER_ID),//外部联系人userId
}
const getters = {
    token: state => state.token,
    externalUserId: state => state.externalUserId,
    isAuthenticated: state => !!state.token,
}
const mutations = {
    setToken(state, token) {
        state.token = token;
        setStorageItem(STORAGE_KEYS.TOKEN, token);
    },
    setExternalUserId(state, externalUserId) {
        state.externalUserId = externalUserId;
        setStorageItem(STORAGE_KEYS.EXTERNAL_USER_ID, externalUserId);
    },
    clearToken(state) {
        state.token = null;
        removeStorageItem(STORAGE_KEYS.TOKEN);
    },
    clearExternalUserId(state) {
        state.externalUserId = null;
        removeStorageItem(STORAGE_KEYS.EXTERNAL_USER_ID);
    }
}
const actions = {
    setToken({commit}, token) {
        commit('setToken', token);
    },
    setExternalUserId({commit}, externalUserId) {
        commit('setExternalUserId', externalUserId);
    },
    clearToken({commit}) {
        commit('clearToken');
    },
    clearExternalUserId({commit}) {
        commit('clearExternalUserId');
    },
    // 从存储中恢复用户状态
    restoreUserState({commit}) {
        const token = getStorageItem(STORAGE_KEYS.TOKEN);
        const externalUserId = getStorageItem(STORAGE_KEYS.EXTERNAL_USER_ID);
        
        if (token) {
            commit('setToken', token);
        }
        if (externalUserId) {
            commit('setExternalUserId', externalUserId);
        }
    },
    // 清除所有用户状态
    clearAllUserData({commit}) {
        commit('clearToken');
        commit('clearExternalUserId');
    }
}
export default {
    state,
    mutations,
    actions,
    getters
}